import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { ViggoCoreComponentsModule } from 'viggo-sistemas-core-web';
import { AutoCompleteUsers } from './components/autocomplete-users/autocomplete-users.component';
import { ChipInputComponent } from './components/chip-input/chip-input.component';
import { DialogDelContatoComponent } from './components/dialog-del-contato/dialog-del-contato.component';
import { DialogEditContatoComponent } from './components/dialog-edit-contato/dialog-edit-contato.component';
import { FastAppHeaderComponent } from './components/fast-app-header/fast-app-header.component';
import { FastAutocompleteComponent } from './components/fast-autocomplete/fast-autocomplete.component';
import { FastCategoriaMateriaComponent } from './components/fast-categoria-materia/fast-categoria-materia.component';
import { FastContatoComponent } from './components/fast-contato/fast-contato.component';
import { FastEnderecoComponent } from './components/fast-endereco/fast-endereco.component';
import { FastFornecedorComponent } from './components/fast-fornecedor/fast-fornecedor.component';
import { FastLocalAgendamentoComponent } from './components/fast-local-agendamento/fast-local-agendamento.component';
import { FastMaterialComponent } from './components/fast-material/fast-material.component';
import { FastMotivoCancelamentoComponent } from './components/fast-motivo-cancelamento/fast-motivo-cancelamento.component';
import { FastPacienteComponent } from './components/fast-paciente/fast-paciente.component';
import { FormInfoPacienteComponent } from './components/fast-paciente/form-info-paciente/form-info-paciente.component';
import { FastParceiroComponent } from './components/fast-parceiro/fast-parceiro.component';
import { FastPlanoSaudeComponent } from './components/fast-plano-saude/fast-plano-saude.component';
import { FastPortadorComponent } from './components/fast-portador/fast-portador.component';
import { FastProcedimentoComponent } from './components/fast-procedimento/fast-procedimento.component';
import { FastProfissionalComponent } from './components/fast-profissional/fast-profissional.component';
import { FormInfoProfissionalComponent } from './components/fast-profissional/form-info-profissional/form-info-profissional.component';
import { FastProtocoloComponent } from './components/fast-protocolo/fast-protocolo.component';
import { FastTipoFormularioComponent } from './components/fast-tipo-formulario/fast-tipo-formulario.component';
import { FastTipoProcedimentoComponent } from './components/fast-tipo-procedimento/fast-tipo-procedimento.component';
import { FastFormatCpfCnpjDirective } from './directive/fast-cpf_cnpj.directive';
import { FastFormatDataDirective } from './directive/fast-date.directive';
import { FastHeaderFormatDirective } from './directive/fast-header.directive';

@NgModule({
  declarations: [
    ChipInputComponent,
    FastEnderecoComponent,
    FastAutocompleteComponent,
    FastParceiroComponent,
    FastContatoComponent,
    DialogEditContatoComponent,
    DialogDelContatoComponent,
    FastFormatDataDirective,
    FastAppHeaderComponent,
    FastHeaderFormatDirective,
    FastFormatCpfCnpjDirective,
    AutoCompleteUsers,
    FastCategoriaMateriaComponent,
    FastProtocoloComponent,
    FastPortadorComponent,
    FastTipoProcedimentoComponent,
    FastProcedimentoComponent,
    FastMaterialComponent,
    FastFornecedorComponent,
    FastTipoFormularioComponent,
    FastPacienteComponent,
    FormInfoPacienteComponent,
    FastProfissionalComponent,
    FormInfoProfissionalComponent,
    FastPlanoSaudeComponent,
    FastLocalAgendamentoComponent,
    FastMotivoCancelamentoComponent
  ],
  imports: [
    CommonModule,
    NgxMaskModule.forChild(),
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ViggoCoreComponentsModule,
    MatCheckboxModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
    MatChipsModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    // primeng modules
    AutoCompleteModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    RippleModule,
    ButtonModule,
    StyleClassModule,
    InputMaskModule,
    TableModule,
    DropdownModule,
    ProgressSpinnerModule,
    DialogModule
  ],
  exports: [
    FastAutocompleteComponent,
    AutoCompleteUsers,
    FastCategoriaMateriaComponent,
    FastProtocoloComponent,
    FastTipoProcedimentoComponent,
    FastProcedimentoComponent,
    FastMaterialComponent,
    FastFornecedorComponent,
    FastTipoFormularioComponent,
    FastPortadorComponent,
    FastPacienteComponent,
    FastProfissionalComponent,
    FastPlanoSaudeComponent,
    FastLocalAgendamentoComponent,
    FastMotivoCancelamentoComponent
  ]
})
export class FastCadastroModule {}
